import get from 'lodash/get';
import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { browserHistory } from 'react-router';

import {
  APPOINTMENT_FORM,
  APPOINTMENT_FORM_CONSENT_FORM,
} from '../../../constants/routes';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';

import {
  selectConsentFormData,
  selectFlowPages,
} from '../../../redux/appointmentForm/selectors';

const useNavigateToPreviousPage = () => {
  const dispatch = useDispatch();

  const { pathname } = window.location;

  const flowPages = useSelector(selectFlowPages);

  const consentData = useSelector(selectConsentFormData);

  const isAllConsentsSigned = get(consentData, 'allSigned');

  const navigateToPrevPage = useCallback(() => {
    const navigatingPagePathname = flowPages.reduce(
      (acc, curr, currentIndex, array) => {
        if (curr === pathname) {
          // eslint-disable-next-line no-param-reassign
          acc = array[currentIndex - 1] || null;
        }
        return acc;
      },
      null,
    );

    browserHistory.replace(navigatingPagePathname);
  }, [pathname, flowPages]);

  useEffect(() => {
    if (isAllConsentsSigned) {
      dispatch(
        appointmentProgressActions.removeFlowPage(
          `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_CONSENT_FORM}`,
        ),
      );
    }
  }, [isAllConsentsSigned]);

  return {
    navigateToPrevPage,
  };
};

export default useNavigateToPreviousPage;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/hooks/useNavigateToPreviousPage.js